export interface WeatherEvent {
  id: string;
  title: string;
  description: string;
  fitters: Record<string, string[]>;
}
